//@ts-nocheck
/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Wiki Integration
 * OpenAPI spec version: latest
 */
import { useMutation, useQuery } from '@tanstack/react-query'
import type {
    DataTag,
    DefinedInitialDataOptions,
    DefinedUseQueryResult,
    MutationFunction,
    QueryClient,
    QueryFunction,
    QueryKey,
    UndefinedInitialDataOptions,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query'

import { useCallback } from 'react'

import { useWikiSwaggerClient } from '../hooks/useWikiSwaggerClient'
export type ApiErrorData = { [key: string]: unknown }

export interface ApiError {
    type?: string
    message?: string
    data?: ApiErrorData
    logToken?: string
    values?: string[]
}

export interface WikiDocument {
    name?: string
    type?: string
    wiki?: string
    xwikiPath?: string
    xwikiUrl?: string
    created?: string
    createdBy?: string
    modified?: string
    modifiedBy?: string
    majorVersion?: number
    minorVersion?: number
}

export type UploadProjectDocumentParams = {
    documentUuid?: string
}

export type GetDocumentParams = {
    createIfNotExists?: boolean
    rerenderDynamicContent?: boolean
}

export type UploadProjectDocument1Params = {
    documentUuid?: string
}

export const useCreateProjectDocumentHook = () => {
    const createProjectDocument = useWikiSwaggerClient<WikiDocument>()

    return useCallback(
        (projectUuid: string, createProjectDocumentBody: number, signal?: AbortSignal) => {
            return createProjectDocument({
                url: `/project/${projectUuid}/document/`,
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: createProjectDocumentBody,
                signal,
            })
        },
        [createProjectDocument],
    )
}

export const useCreateProjectDocumentMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateProjectDocumentHook>>>,
        TError,
        { projectUuid: string; data: number },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateProjectDocumentHook>>>,
    TError,
    { projectUuid: string; data: number },
    TContext
> => {
    const mutationKey = ['createProjectDocument']
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } }

    const createProjectDocument = useCreateProjectDocumentHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateProjectDocumentHook>>>,
        { projectUuid: string; data: number }
    > = (props) => {
        const { projectUuid, data } = props ?? {}

        return createProjectDocument(projectUuid, data)
    }

    return { mutationFn, ...mutationOptions }
}

export type CreateProjectDocumentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateProjectDocumentHook>>>>
export type CreateProjectDocumentMutationBody = number
export type CreateProjectDocumentMutationError = ApiError

export const useCreateProjectDocument = <TError = ApiError, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateProjectDocumentHook>>>,
            TError,
            { projectUuid: string; data: number },
            TContext
        >
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateProjectDocumentHook>>>,
    TError,
    { projectUuid: string; data: number },
    TContext
> => {
    const mutationOptions = useCreateProjectDocumentMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}

export const useGetProjectDocumentHook = () => {
    const getProjectDocument = useWikiSwaggerClient<WikiDocument>()

    return useCallback(
        (projectUuid: string, documentId: number, signal?: AbortSignal) => {
            return getProjectDocument({ url: `/project/${projectUuid}/document/${documentId}`, method: 'GET', signal })
        },
        [getProjectDocument],
    )
}

export const getGetProjectDocumentQueryKey = (projectUuid?: string, documentId?: number) => {
    return [`/project/${projectUuid}/document/${documentId}`] as const
}

export const useGetProjectDocumentQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError, TData>> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetProjectDocumentQueryKey(projectUuid, documentId)

    const getProjectDocument = useGetProjectDocumentHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>> = ({ signal }) =>
        getProjectDocument(projectUuid, documentId, signal)

    return { queryKey, queryFn, enabled: !!(projectUuid && documentId), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProjectDocumentQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>>
export type GetProjectDocumentQueryError = ApiError

export function useGetProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetProjectDocumentHook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetProjectDocumentQueryOptions(projectUuid, documentId, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useUpdateProjectDocumentHook = () => {
    const updateProjectDocument = useWikiSwaggerClient<WikiDocument>()

    return useCallback(
        (projectUuid: string, documentId: number) => {
            return updateProjectDocument({ url: `/project/${projectUuid}/document/${documentId}`, method: 'PATCH' })
        },
        [updateProjectDocument],
    )
}

export const useUpdateProjectDocumentMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useUpdateProjectDocumentHook>>>,
        TError,
        { projectUuid: string; documentId: number },
        TContext
    >
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectDocumentHook>>>,
    TError,
    { projectUuid: string; documentId: number },
    TContext
> => {
    const mutationKey = ['updateProjectDocument']
    const { mutation: mutationOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey } }

    const updateProjectDocument = useUpdateProjectDocumentHook()

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useUpdateProjectDocumentHook>>>,
        { projectUuid: string; documentId: number }
    > = (props) => {
        const { projectUuid, documentId } = props ?? {}

        return updateProjectDocument(projectUuid, documentId)
    }

    return { mutationFn, ...mutationOptions }
}

export type UpdateProjectDocumentMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateProjectDocumentHook>>>>

export type UpdateProjectDocumentMutationError = ApiError

export const useUpdateProjectDocument = <TError = ApiError, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useUpdateProjectDocumentHook>>>,
            TError,
            { projectUuid: string; documentId: number },
            TContext
        >
    },
    queryClient?: QueryClient,
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useUpdateProjectDocumentHook>>>,
    TError,
    { projectUuid: string; documentId: number },
    TContext
> => {
    const mutationOptions = useUpdateProjectDocumentMutationOptions(options)

    return useMutation(mutationOptions, queryClient)
}

export const useUploadProjectDocumentHook = () => {
    const uploadProjectDocument = useWikiSwaggerClient<string>()

    return useCallback(
        (projectUuid: string, documentId: number, params?: UploadProjectDocumentParams, signal?: AbortSignal) => {
            return uploadProjectDocument({ url: `/project/${projectUuid}/document/${documentId}/upload`, method: 'GET', params, signal })
        },
        [uploadProjectDocument],
    )
}

export const getUploadProjectDocumentQueryKey = (projectUuid?: string, documentId?: number, params?: UploadProjectDocumentParams) => {
    return [`/project/${projectUuid}/document/${documentId}/upload`, ...(params ? [params] : [])] as const
}

export const useUploadProjectDocumentQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    params?: UploadProjectDocumentParams,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError, TData>> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getUploadProjectDocumentQueryKey(projectUuid, documentId, params)

    const uploadProjectDocument = useUploadProjectDocumentHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>> = ({ signal }) =>
        uploadProjectDocument(projectUuid, documentId, params, signal)

    return { queryKey, queryFn, enabled: !!(projectUuid && documentId), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UploadProjectDocumentQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>>
export type UploadProjectDocumentQueryError = ApiError

export function useUploadProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    params: undefined | UploadProjectDocumentParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUploadProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    params?: UploadProjectDocumentParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUploadProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    params?: UploadProjectDocumentParams,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUploadProjectDocument<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError = ApiError>(
    projectUuid: string,
    documentId: number,
    params?: UploadProjectDocumentParams,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocumentHook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useUploadProjectDocumentQueryOptions(projectUuid, documentId, params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useGetDocumentHook = () => {
    const getDocument = useWikiSwaggerClient<WikiDocument>()

    return useCallback(
        (entityType: string, entityId: string, documentType: string, params?: GetDocumentParams, signal?: AbortSignal) => {
            return getDocument({ url: `/document/${entityType}/${entityId}/document/${documentType}`, method: 'GET', params, signal })
        },
        [getDocument],
    )
}

export const getGetDocumentQueryKey = (entityType?: string, entityId?: string, documentType?: string, params?: GetDocumentParams) => {
    return [`/document/${entityType}/${entityId}/document/${documentType}`, ...(params ? [params] : [])] as const
}

export const useGetDocumentQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: GetDocumentParams,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError, TData>> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getGetDocumentQueryKey(entityType, entityId, documentType, params)

    const getDocument = useGetDocumentHook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>> = ({ signal }) =>
        getDocument(entityType, entityId, documentType, params, signal)

    return { queryKey, queryFn, enabled: !!(entityType && entityId && documentType), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>>
export type GetDocumentQueryError = ApiError

export function useGetDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params: undefined | GetDocumentParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: GetDocumentParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: GetDocumentParams,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDocument<TData = Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: GetDocumentParams,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetDocumentHook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useGetDocumentQueryOptions(entityType, entityId, documentType, params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}

export const useUploadProjectDocument1Hook = () => {
    const uploadProjectDocument1 = useWikiSwaggerClient<string>()

    return useCallback(
        (entityType: string, entityId: string, documentType: string, params?: UploadProjectDocument1Params, signal?: AbortSignal) => {
            return uploadProjectDocument1({
                url: `/document/${entityType}/${entityId}/document/${documentType}/upload`,
                method: 'GET',
                params,
                signal,
            })
        },
        [uploadProjectDocument1],
    )
}

export const getUploadProjectDocument1QueryKey = (
    entityType?: string,
    entityId?: string,
    documentType?: string,
    params?: UploadProjectDocument1Params,
) => {
    return [`/document/${entityType}/${entityId}/document/${documentType}/upload`, ...(params ? [params] : [])] as const
}

export const useUploadProjectDocument1QueryOptions = <
    TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>,
    TError = ApiError,
>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: UploadProjectDocument1Params,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError, TData>> },
) => {
    const { query: queryOptions } = options ?? {}

    const queryKey = queryOptions?.queryKey ?? getUploadProjectDocument1QueryKey(entityType, entityId, documentType, params)

    const uploadProjectDocument1 = useUploadProjectDocument1Hook()

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>> = ({ signal }) =>
        uploadProjectDocument1(entityType, entityId, documentType, params, signal)

    return { queryKey, queryFn, enabled: !!(entityType && entityId && documentType), ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UploadProjectDocument1QueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>>
export type UploadProjectDocument1QueryError = ApiError

export function useUploadProjectDocument1<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params: undefined | UploadProjectDocument1Params,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUploadProjectDocument1<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: UploadProjectDocument1Params,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>,
                    TError,
                    Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>
                >,
                'initialData'
            >
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUploadProjectDocument1<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: UploadProjectDocument1Params,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUploadProjectDocument1<TData = Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError = ApiError>(
    entityType: string,
    entityId: string,
    documentType: string,
    params?: UploadProjectDocument1Params,
    options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUploadProjectDocument1Hook>>>, TError, TData>> },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = useUploadProjectDocument1QueryOptions(entityType, entityId, documentType, params, options)

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

    query.queryKey = queryOptions.queryKey

    return query
}
